import { Link } from "react-router-dom";
import { PunchHoles } from "@/components/Doc";

export const FolderCard = ({ m }) => (
  <div className="relative" data-testid={`module-card-${m.slug}`}>
    <div className="inline-block folder-tab active !top-0 !border-rule !bg-manila !text-carbon !pt-[0.7em]">Module {m.numeral} — {m.title}</div>
    <div className="relative bg-manila border border-rule pl-12 pr-6 py-7 -mt-px">
      <PunchHoles />
      <p className="t-label text-olive">{m.who}</p>
      <p className="t-body text-lg mt-4 leading-snug">
        <span className="t-label text-rule block mb-1">Names the problem</span>
        {m.problem}
      </p>
      <ul className="mt-5 flex flex-col gap-1">
        {m.artifacts.map((a) => (
          <li key={a} className="t-label text-carbon flex gap-2"><span className="text-rule">—</span>{a}</li>
        ))}
      </ul>
      <Link to={`/modules/${m.slug}`} className="t-label inline-block mt-6 text-carbon hover:text-stamp transition-colors" data-testid={`read-module-${m.slug}`}>
        Read the module →
      </Link>
    </div>
  </div>
);
